import * as gs from "@ivanlog/gs";
import * as com from "./tmpls";
import { LPXInfrastructure } from "../contracts/LPXInfrastructure";
import { App } from "../App";
import { ERC20Contract } from "../contracts/ERC20Contract";
import { BiMath } from "../libs/BiMath";
import { LPXInfo } from "../api/classes/models";
import { Web3Helper } from "../libs/Web3Helper";
import { Helper } from "../libs/Helper";

export class CmpWidgetLPXCtrl extends com.CmpWidgetLPXCtrlBase {

    private _lpxInf:LPXInfrastructure;
    private _pool:LPXInfo;

    private _resFund:bigint;
    private _resAnchor:bigint;
    private _fundDecimal:bigint = BiMath.Decimal;
    private _anchorDecimal:bigint = BiMath.Decimal;
    
    constructor() {
        super();
        this.hide();
        const ctrl = this.ctrls;

        ctrl.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.lSubText.text=
        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.lSubText.text="Fund";

        ctrl.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.lSubText.text=
        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.lSubText.text="Anchor";

        ctrl.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.iValue.disable();
        ctrl.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.iValue.disable();

        ctrl.btnAddLiquidity.onclick=async ()=>{
            await App.gui.awaitInLockUIAsync(this._tryAddLiquidityAsync());
        }
        ctrl.btnRemoveLiquidity.onclick=async ()=>{
            await App.gui.awaitInLockUIAsync(this._tryRemoveLiquidityAsync());
        }

        ctrl.rRemoveLiquidityPart.onChangeValue.addHandler((value)=>this._setRemoveRatio(value));
        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.iValue.el.addEventListener("input",()=>this._setLiqFundValue());
        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.iValue.el.addEventListener("input",()=>this._setLiqAnchorValue());

        ctrl.tglAddLiquidity.show();
        ctrl.tglRemoveLiquidity.onclick=async ()=>{
            if (!ctrl.tglRemoveLiquidity.isActive) return;
            if (this._pool.shareMy.shareRaw=="0") return;
            //if (!this._share) this._share = await this._lpxInf.lpx.shares(this._pool.poolId, App.chain.account);
        }
    }

    private _setRemoveRatio(value){
        this.ctrls.rRemoveLiquidityPart.value=value;
        this.ctrls.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.iValue.value =
        this.ctrls.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.iValue.value = "";
        this.ctrls.btnRemoveLiquidity.disable();
        if (this._pool.shareMy.shareRaw=="0") { this.ctrls.rRemoveLiquidityPart.value=0; return;}
        const totalSharesBI = BiMath.WEIToBI(this._pool.sharesTotalRaw);
        if (totalSharesBI==BiMath.Zero) {this.ctrls.rRemoveLiquidityPart.value=0; return;}
        if (value>0) this.ctrls.btnRemoveLiquidity.enable();
        const takeShare = BiMath.WEIToBI(this._pool.shareMy.shareRaw)*BiMath.Decimal/totalSharesBI*BigInt(value)/100n;

        this.ctrls.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.iValue.value 
            = BiMath.ToEth((this._resFund*takeShare)/BiMath.Decimal*BiMath.Decimal/this._fundDecimal)
        this.ctrls.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.iValue.value 
            = BiMath.ToEth((this._resAnchor*takeShare)/BiMath.Decimal*BiMath.Decimal/this._anchorDecimal)
    }

    private _setLiqFundValue(){
        const ctrl = this.ctrls.cmpAddLiquidityTokens.ctrls;
        const value = ctrl.cmpInputTokenAmount0.ctrls.iValue.value;
        if (!value) {ctrl.cmpInputTokenAmount1.ctrls.iValue.value=''; return;}
        if (BiMath.WEIToBI(this._pool.reserves.fundRaw)=== 0n) {ctrl.cmpInputTokenAmount1.ctrls.iValue.value=''; return;}
        let valueBi = BiMath.ToBI(value);
        valueBi=valueBi*this._fundDecimal/BiMath.Decimal
        ctrl.cmpInputTokenAmount1.ctrls.iValue.value =
            BiMath.ToEth(
                ((this._resAnchor*BiMath.Decimal)/this._resFund)*valueBi/BiMath.Decimal
               // *BigInt(1001)/BigInt(1000)
                *BiMath.Decimal/this._anchorDecimal
        );
    }
    private _setLiqAnchorValue(){
        const ctrl = this.ctrls.cmpAddLiquidityTokens.ctrls;
        const value = ctrl.cmpInputTokenAmount1.ctrls.iValue.value;
        if (!value) {ctrl.cmpInputTokenAmount0.ctrls.iValue.value=''; return;}
        if (BiMath.WEIToBI(this._pool.reserves.anchorRaw)=== 0n) {ctrl.cmpInputTokenAmount0.ctrls.iValue.value=''; return;}
        let valueBi = BiMath.ToBI(value);
        valueBi=valueBi*this._anchorDecimal/BiMath.Decimal
        ctrl.cmpInputTokenAmount0.ctrls.iValue.value =
            BiMath.ToEth(
                ((this._resFund*BiMath.Decimal)/this._resAnchor)*valueBi/BiMath.Decimal
               // *BigInt(1001)/BigInt(1000)
                *BiMath.Decimal/this._fundDecimal
        );
    }

    private _fundAdr="";
    private _acnhorAdr="";
    public async refreshAsync(pool:LPXInfo)
    {
        await Helper.awaitTime(100);
        const account = App.chain.account;   
        this._pool=pool;
        this._resFund = BiMath.WEIToBI(this._pool.reserves.fundRaw);
        this._resAnchor = BiMath.WEIToBI(this._pool.reserves.anchorRaw);

        //this._config=pool.packRaw;
        //this._poolReserve=poolReserve;
        const lpxInf=App.Inst.getInst(LPXInfrastructure);
        this._lpxInf=lpxInf;


                //TODO подумать о фии и переделать

        const fundAdr = this._pool.fundToken.erc20Address;
        const anchorAdr = this._pool.anchorToken.erc20Address;
        this._fundAdr = fundAdr;
        this._acnhorAdr = anchorAdr;
        this._fundDecimal = BiMath.Pow10(this._pool.fundToken.decimals);
        this._anchorDecimal = BiMath.Pow10(this._pool.anchorToken.decimals);

        const fundSymbol = this._pool.fundToken.symbol;
        const anchorSymbol = this._pool.anchorToken.symbol;









        const ctrl = this.ctrls;

        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.iValue.value='';
        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.iValue.value='';

        ctrl.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount0.setToken(fundSymbol, fundAdr);
        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount0.setToken(fundSymbol, fundAdr);

        ctrl.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount1.setToken(anchorSymbol, anchorAdr);
        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount1.setToken(anchorSymbol, anchorAdr);
        // ctrl.cmpClaimYield.setToken(anchorSymbol, anchorAdr);
        // ctrl.cmpClaimArbProfit.setToken(anchorSymbol, anchorAdr);

        //ctrl.cmpLPXControl.ctrls.cmpNewAnchorAdr

       // ctrl.tglClaimYield.inactive();
       //ctrl.tglRemoveLiquidity.inactive();

        const pack = this._lpxInf.unpackConfigPack(BiMath.WEIToBI(this._pool.packRaw));

        //Рассчет индексов
        const ntzEth = pack.ntzIndex*BiMath.Decimal/BiMath.Decimal17B*100n;
        const feeEth = pack.feeIndex*BiMath.Decimal/BiMath.Decimal17B*100n;//; BiMath.ToEth(feeBI/BigInt(2)*BigInt(100));
       
        const baseEth = ntzEth - (feeEth * 2n);

        const profitEth = pack.profitIndex*BiMath.Decimal/BiMath.Decimal17B*100n;
        let reinvestEth = 0n;
        if (pack.ntzIndex>pack.profitIndex+pack.feeIndex*BigInt(2))
            reinvestEth = ntzEth-profitEth-(feeEth*2n);
        const profitIndexEth = profitEth*BiMath.Decimal*100n/baseEth;
        const reinvestIndexEth = reinvestEth*BiMath.Decimal*100n/baseEth;
        //    reinvestEthP = BiMath.ToEth((pack.ntzIndex-(pack.profitIndex+pack.feeIndex*BigInt(2)))*BiMath.Decimal/BiMath.Decimal17B*BigInt(100));



       
       
        // let ntzBaseIndex = BiMath.Zero;
        // if (pack.ntzIndex>pack.feeIndex) ntzBaseIndex = pack.ntzIndex-pack.feeIndex;

        // let profitEthP = "0";
        // if (ntzBaseIndex>0) profitEthP = BiMath.ToEth(pack.profitIndex*BiMath.Decimal/ntzBaseIndex*BigInt(100));

        // let reinvestBaseIndex = BiMath.Zero;
        // if (ntzBaseIndex>pack.profitIndex) reinvestBaseIndex = ntzBaseIndex-pack.profitIndex;
        // let reinvestEthP = "0";
        // if (ntzBaseIndex>0) reinvestEthP = BiMath.ToEth(reinvestBaseIndex*BiMath.Decimal/ntzBaseIndex*BigInt(100));
        //const managerRewardEthP = BiMath.ToEth(pack.managerRewardIndex*BiMath.Decimal/BiMath.Decimal17B*BigInt(100));
        // const rewardIndexEthP = BiMath.ToEth(BiMath.ToBI(poolConfig.rewardIndex)*BigInt(100));
        // const totalProfBi = BiMath.ToBI(rewardIndexEthP)+BiMath.ToBI(feeEthP)*BigInt(2);
        // const reinvestEthP = (totalProfBi>=BiMath.ToBI(ntzEthP)?"0":BiMath.ToEth(BiMath.ToBI(ntzEthP)-totalProfBi));

        this.show();

        if (!account)
        {
            this.hide();
            return;
        } else
        {
            this.show();
        }

        ctrl.tglStartPool.show();
        ctrl.tglRemoveLiquidity.show();
        ctrl.tglAddLiquidity.show();

        
        if (this._pool.sharesTotalRaw=="0")
        {
            ctrl.tglRemoveLiquidity.hide();
            ctrl.tglAddLiquidity.hide();
            ctrl.tglStartPool.el.click();
            await ctrl.blockStartPool.refreshAsync(pool);
        } else 
        {
            ctrl.tglStartPool.hide();
            if (BiMath.WEIToBI(this._pool.shareMy.shareRaw)==0n)
            {
                ctrl.tglAddLiquidity.el.click();
                ctrl.tglRemoveLiquidity.hide();
            } else if (ctrl.tglStartPool.active)
                ctrl.tglAddLiquidity.el.click();
            this._setRemoveRatio(0);
        }

    }

    private async _tryAddLiquidityAsync()
    {
        const fundAdr = this._pool.fundToken.erc20Address;
        const anchorAdr = this._pool.anchorToken.erc20Address;
        const valueFund = this.ctrls.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.iValue.value;
        const valueAnchor = this.ctrls.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.iValue.value;
        let valueFundBi = BiMath.ToBI(valueFund)*this._fundDecimal/BiMath.Decimal;
        let valueAnchorBi = BiMath.ToBI(valueAnchor)*this._anchorDecimal/BiMath.Decimal*BigInt(1001)/BigInt(1000);
        let valuePayBi=BiMath.Zero;

        const erc20Fund = new ERC20Contract(fundAdr, App.chain.provider);
        const erc20Anchor = new ERC20Contract(anchorAdr, App.chain.provider);
        const balanceEth = await App.chain.getBalanceEth();
        if (balanceEth === undefined)
        {
            App.gui.dialogOkShowAsync("Unable to read wallet balance. Please reconnect wallet and try again.");
            return;
        }

        if (fundAdr!=LPXInfrastructure.ADDRESS_WPLS)
        {
            const balanceFund = await erc20Fund.balanceOf(App.chain.account);
            if (BiMath.ToBI(balanceFund)<valueFundBi) 
            {
                App.gui.dialogOkShowAsync("Insufficient funds");
                return;
            }
        } else
        {
            if (BiMath.ToBI(balanceEth)<valueFundBi)
            {
                App.gui.dialogOkShowAsync("Insufficient funds");
                return;
            }
            valuePayBi = valueFundBi;
        }

        if (anchorAdr!=LPXInfrastructure.ADDRESS_WPLS)
        {
            const balanceAnchor = await erc20Anchor.balanceOf(App.chain.account);
            if (BiMath.ToBI(balanceAnchor)<valueAnchorBi) 
            {
                App.gui.dialogOkShowAsync("Insufficient anchor");
                return;
            }
        } else
        {
            if (BiMath.ToBI(balanceEth)<valueAnchorBi)
            {
                App.gui.dialogOkShowAsync("Insufficient anchor");
                return;
            }
            valuePayBi = valueAnchorBi;
        }

        const stepTx0 = App.gui.getTxLockText();
        const stepTx1="1/2 Transaction in progress.\nToken approval pending.\nPlease wait for it to finish.\nThis may take a few minutes.\n\nThe second transaction will start automatically.";
        const stepTx2="2/2 Transaction in progress.\nPlease wait for it to finish.\nThis may take a few minutes";

        if (fundAdr!=LPXInfrastructure.ADDRESS_WPLS)
        {
            const approved = await erc20Fund.allowance(App.chain.account, this._lpxInf.lpx.address);
            if (BiMath.ToBI(approved)<valueFundBi)
            {
                App.gui.setTxLockText(stepTx1);
                const approveResult = await erc20Fund.approve(this._lpxInf.lpx.address, BiMath.ToEth(valueFundBi));
                if (!approveResult) {App.gui.setTxLockText(stepTx0); return;}
                App.gui.setTxLockText(stepTx2);
            }
        } 
        if (anchorAdr!=LPXInfrastructure.ADDRESS_WPLS)
        {
            const approved = await erc20Anchor.allowance(App.chain.account, this._lpxInf.lpx.address);
            if (BiMath.ToBI(approved)<valueAnchorBi)
            {
                App.gui.setTxLockText(stepTx1);
                const approveResult = await erc20Anchor.approve(this._lpxInf.lpx.address, BiMath.ToEth(valueAnchorBi));
                if (!approveResult) {App.gui.setTxLockText(stepTx0); return;}
                App.gui.setTxLockText(stepTx2);
            }
        }
        const result = await this._lpxInf.lpxCtrlPools.addLiquidity(BiMath.ToEth(valuePayBi), this._pool.poolId, BiMath.ToEth(valueFundBi), BiMath.ToEth(valueAnchorBi));
        if (result) this._informTxSuccessful();
        App.gui.setTxLockText(stepTx0);
        this._lpxInf.refreshAsync();
    }

    
    private async _tryRemoveLiquidityAsync()
    {
        const value = this.ctrls.rRemoveLiquidityPart.value;
        if (!value) return;
        const share = await this._lpxInf.lpx.shares(this._pool.poolId, App.chain.account);
        if (!share) { return; }
        const takeShare = share.share*BigInt(value)/BigInt(100);
        const result = await this._lpxInf.lpxCtrlPools.removeLiquidity(this._pool.poolId,BiMath.ToEth(takeShare));
        if (result) this._informTxSuccessful();
        this._lpxInf.refreshAsync();
    }

    private _informTxSuccessful() { App.gui.dialogOkShowAsync("✅Transaction successful!","") }
}
